import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/responsive.css'
import { formatDateTime, formatDate, formatTime, formatRelativeTime, formatDateTimeRange } from './utils/date'

Vue.use(ElementUI)

// 注册全局时间格式化方法
Vue.prototype.$formatDateTime = formatDateTime
Vue.prototype.$formatDate = formatDate
Vue.prototype.$formatTime = formatTime
Vue.prototype.$formatRelativeTime = formatRelativeTime
Vue.prototype.$formatDateTimeRange = formatDateTimeRange

// 注册全局图片URL处理方法 - 将http转为https
Vue.prototype.$ensureHttpsUrl = function(url) {
  if (!url || typeof url !== 'string') return url
  if (url.startsWith('https://')) return url
  if (url.startsWith('http://')) return url.replace(/^http:/, 'https:')
  if (!url.includes('://')) return `https://${url}`
  return url
}

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

